import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { Payments } from '@widgets/payments/Payments';

export const Route = createFileRoute('/profile/payments')({
  component: RouteComponent,
});

function RouteComponent() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page>
        <Payments />
      </Page>
    </>
  );
}
